import React from 'react';
import Icon from '../../../../Icon/Icon';
import s from './ProductAvailability.scss';

interface ProductAvailabilityProps {
  isAvailableInStore: boolean;
  storeAvailabilityMessage?: React.ReactNode;
}

const ProductAvailability: React.FC<ProductAvailabilityProps> = ({
  isAvailableInStore,
  storeAvailabilityMessage = 'Store Pickup Available',
}) => {
  if (isAvailableInStore) {
    return (
      <div className={s.storeAvailabilityContainer}>
        <div className={s.greenDotContainer}>
          <Icon icon="greenDot" />
        </div>
        <div className={s.storeAvailabilityMessage}>
          {storeAvailabilityMessage}
        </div>
      </div>
    );
  }

  return null;
};
export default ProductAvailability;
